<script setup lang="ts">
import { z } from 'zod'
import IdentificationIcon from '~/assets/icons/communication/identification.svg'
import PhoneIcon from '~/assets/icons/communication/phone.svg'

const { $i18n } = useNuxtApp()
const viewSchema = z.enum(['email', 'phone'])
const { tabs, view } = useTabs(viewSchema, 'email', computed(() => ({
  email: { label: $i18n.t('account.registration.tabs.email'), icon: IdentificationIcon },
  phone: { label: $i18n.t('account.registration.tabs.phone'), icon: PhoneIcon },
})))
</script>

<template>
  <TheTabs :tabs="tabs" :view="view" text-class="text-base">
    <TheDataCard
      :title="$t(`button.register.citizen`)"
      padding-class="px-2"
      header-class="bg-gray-200 !justify-center"
    >
      <div class="max-h-[60vh] overflow-y-auto p-2">
        <AccountRegistrationUserTabsEmail :tab="tabs.email" />
        <AccountRegistrationUserTabsPhone :tab="tabs.phone" />
      </div>
    </TheDataCard>
  </TheTabs>
</template>
